"use client";

import { createContext, useContext } from "react";
import type {
  AuthUser,
  UserRole,
} from "@/services/domains/identity/auth-types";

// Re-export for consumers that import from AuthContext
export type {
  AuthUser,
  UserRole,
} from "@/services/domains/identity/auth-types";
export { sanitizeUserData } from "@/services/domains/identity/auth-types";

interface AuthContextType {
  user: AuthUser | null;
  isPending: boolean;
  login: (
    email: string,
    password: string,
    rememberMe?: boolean,
  ) => Promise<void>;
  logout: () => void;
  isAuthenticated: boolean;
  hasRole: (role: UserRole) => boolean;
  refreshToken: () => Promise<void>;
  isPlatformAdmin: () => boolean;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);

/**
 * Hook to access auth context
 */
export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
